export const ListSelectionTypes = {
  DEFAULT: 'default',
  SINGLE_SELECTION: 'singleSelection',
  MULTI_SELECTION: 'multiSelection'
};
export const truncateFromMiddle = function () {
  let fullStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let strLen = arguments.length > 1 ? arguments[1] : undefined;
  if (fullStr.length <= strLen) return fullStr;
  const middleStr = '...';
  const midLen = middleStr.length;
  const charsToShow = strLen - midLen;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);
  return fullStr.substring(0, frontChars) + middleStr + fullStr.substring(fullStr.length - backChars);
};